import FiltersBar from "./FiltersBar";
export default FiltersBar;



// WEBPACK FOOTER //
// ./src/components/App/Trips/FiltersBar/index.js